import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {ContractPolicyComponent} from 'src/app/components/contract-policy/contract-policy.component';
import { ContractSummary } from '../../models/interface-contract-summary';
import { HttpClient } from '@angular/common/http';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { PrivateAreaService } from '../../services/private-area.service';
import { Router } from '@angular/router';

declare var RealexHpp: any;

@Component({
    selector: 'app-contract-summary',
    templateUrl: './contract-summary.component.html',
    styleUrls: ['./contract-summary.component.scss']
})
export class ContractSummaryComponent implements OnInit {
    textMessage: string;
    textMessageError: string;
    modalId: string;
    dataRenovation: ContractSummary;
    contractSummaryCheck: FormGroup;
    showLoader = false;
    legalScrollOK = false;

    constructor(public privateAreaService: PrivateAreaService, private router: Router) {
        this.dataRenovation = JSON.parse(sessionStorage.getItem('dataRenovation'));
        this.contractSummaryCheck = new FormGroup({
            acceptConditions: new FormControl(false, Validators.requiredTrue)
        });
    }

    ngOnInit(): void {
        if (!this.dataRenovation) {
            this.router.navigateByUrl('/contratos');
        }
        this.modalId = 'modal-error';
    }

    get form() {
        return this.contractSummaryCheck.controls.acceptConditions;
    }



    onSubmit() {
        this.contractSummaryCheck.markAllAsTouched();
        if (this.contractSummaryCheck.status === 'VALID' && this.legalScrollOK) {
            this.showLoader = true;
            this.privateAreaService.ContractRenewal(this.dataRenovation.codContrato,
                this.dataRenovation.sequence).subscribe(resp => {
                    sessionStorage.setItem('cod_contract', this.dataRenovation.codContrato.toString());
                    if (resp.gateway === 'TPV') {
                        /*
                            TEST CREDIT CARDS
                            5540500001000004 Caducidad: AAAA12 (Diciembre del año en curso) CVV2: 989
                            5020470001370055 Caducidad: AAAA12 (Diciembre del año en curso) CVV2: 989
                            5020080001000006 Caducidad: AAAA12 (Diciembre del año en curso) CVV2: 989
                            4507670001000009 Caducidad: AAAA12 (Diciembre del año en curso) CVV2: 989
                        */

                        window.location.href = resp.paymentUrl;
                    }
                    else if (resp.gateway === 'GP') {

                         /*
                            https://developer.globalpay.com/resources/test-card-numbers
                            4263970000005262	Visa	Successful	00	Successful transaction
                            5425230000004415	Mastercard	Successful	00	Successful transaction
                            4000120000001154	Visa	Declined	101	Declined by the bank
                            4000130000001724	Visa	Declined	102	Referral B
                        */
                        this.showLoader = false;
                        RealexHpp.setHppUrl(resp.hppUrl);
                        RealexHpp.lightbox.init('autoload'
                            , (evtdata, _close) => {
                                _close();
                                this.showLoader = true;
                                this.privateAreaService.gpPaymentResult(
                                    resp.hppConfirmUrl,
                                evtdata,
                                (returnUrl) => window.location.href = returnUrl,
                                (error) => {
                                    this.textMessage = error.error;
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                }
                                );

                            }
                            , JSON.parse(resp.paymentUrl));
                    }
                }, error => {
                    this.showLoader = false;
                    this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                    document.getElementById(this.modalId).classList.remove('d-none');
                });
        }
    }


    divScroll(id) {
        const elem = document.getElementById(id);
        //console.log(elem.scrollTop.toString() + ":" + (elem.scrollHeight - elem.offsetHeight).toString());
        if (Math.abs(elem.scrollTop - (elem.scrollHeight - elem.offsetHeight))<5) {
            this.legalScrollOK = true;
        }
    }
}
